﻿window.AddResizeListener = (function () {
    let initialized = false;

    return function () {
        if (initialized) return;
        initialized = true;

        // Coalesce to one repaint per frame (like the scroll handler) instead of a
        // trailing debounce, so the sticky-column shadow appears/disappears live as
        // the window is dragged rather than only after the resize settles.
        let scheduled = false;
        const onResize = function () {
            if (scheduled) return;
            scheduled = true;
            requestAnimationFrame(function () {
                scheduled = false;
                window.CheckIfScrolling();
            });
        };

        window.addEventListener('resize', onResize);
    };
})();
function debounce(fn, delay) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn(...args);
        }, delay);
    };
}

window.CheckIfScrolling = function () {
    // grab all grids on page
    let grids = document.querySelectorAll(".ebizgrid");

    grids.forEach(grid => {
        let gridContent = grid
            .querySelector(".k-grid-aria-root")
            ?.querySelector(".k-grid-container")
            ?.querySelector(".k-grid-content");

        if (gridContent) {
            window.ApplyBoxShadowToGridContent(grid, gridContent, { layoutDetails: true });

            if (!gridContent.__ebizScrollHandlerAttached) {
                // Coalesce to one repaint per frame, and skip the detail-subgrid
                // layout pass on scroll — the fit decision depends on viewport and
                // table widths, not scroll position, so it only needs to run from
                // the render/resize path above.
                //
                // NOTE: nothing applied from this path may depend on scrollLeft.
                // Scrolling is composited — the browser presents frames between
                // main-thread updates — so any scroll-position-derived style is
                // stale on those frames (this is how sticky cells used to get
                // clipped away mid-fling, letting the columns behind bleed
                // through). Viewport-edge visuals (corner rounding) are done with
                // elements that ride inside the sticky cells instead.
                let scheduled = false;
                gridContent.addEventListener('scroll', function () {
                    if (scheduled) return;
                    scheduled = true;
                    requestAnimationFrame(() => {
                        scheduled = false;
                        window.ApplyBoxShadowToGridContent(grid, gridContent, { layoutDetails: false });
                    });
                });
                gridContent.__ebizScrollHandlerAttached = true;
            }
        } else {
            console.warn("k-grid-content not found for a grid.");
        }
    });
};


truncateDiv = null;


window.gridTooltip = {
    handleMouseEnter: function (title, clientX, clientY) {
        const el = document.elementFromPoint(clientX, clientY);
        if (!el) return;

        const elementRef = el.closest('.grid-truncate');
        if (!elementRef) {
            return;
        } else {
            truncateDiv = elementRef;
        }

        if (truncateDiv.querySelector('.toggle-switch-container')) {
            return;
        }

        const deepest = findDeepestTextNode(truncateDiv);
        if (title && deepest && deepest.scrollWidth > deepest.clientWidth) {
            truncateDiv.setAttribute('title', title);
            truncateDiv.classList.add('grid-cell-tooltip-target');

            setTimeout(() => {
                const mouseEvent = new MouseEvent('mouseenter', { bubbles: true });
                truncateDiv.dispatchEvent(mouseEvent);
            }, 0);
        }
    },

    handleMouseLeave: function () {
        if (truncateDiv) {
            truncateDiv.classList.remove('grid-cell-tooltip-target');
            truncateDiv.removeAttribute('title');
        }
    }
}

window.ExcelFileDownload = function (fileName, contentType, base64Data) {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: contentType });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    // Append to body so Firefox can intercept the download event through the DOM
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
};

// helper for tooltip (private)
function findDeepestTextNode(root) {
    let deepest = null;

    function traverse(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
            const style = window.getComputedStyle(node);
            const hasText = node.textContent?.trim().length > 0;
            const isVisible = style.display !== 'none' && style.visibility !== 'hidden';

            if (hasText && isVisible && node.scrollWidth > node.clientWidth) {
                deepest = node;
            }

            for (let child of node.children) {
                traverse(child);
            }
        }
    }

    traverse(root);
    return deepest;
}

window.telerikSortIconHelpers = {
    hideAllSortIcons: function (gridSelector) {
        const grid = document.querySelector(gridSelector);
        if (!grid) return;
        grid.querySelectorAll('.k-sort-icon').forEach(function (el) {
            if (!el.closest('.radio-header, .checkbox-column-header')) {
                el.classList.remove('show');
            }
        });
    },
    showAllSortIcons: function (gridSelector) {
        const grid = document.querySelector(gridSelector);
        if (!grid) return;
        grid.querySelectorAll('.k-sort-icon').forEach(function (el) {
            if (!el.closest('.radio-header, .checkbox-column-header')) {
                el.classList.add('show');
            }
        });
    }
};

window.clickOutsideHelper = (function () {
    const listeners = new Map();
    let mouseDownPos = null;
    const DRAG_THRESHOLD = 5;

    document.addEventListener('mousedown', (e) => {
        mouseDownPos = { x: e.clientX, y: e.clientY };
    });

    return {
        initialize: function (dotnetHelper, elementIds, instanceId) {
            if (listeners.has(instanceId)) {
                document.removeEventListener('click', listeners.get(instanceId));
            }

            const listener = (e) => {
                // Ignore drag-releases: mousedown started far from where mouseup fired
                if (mouseDownPos) {
                    const dx = e.clientX - mouseDownPos.x;
                    const dy = e.clientY - mouseDownPos.y;
                    if (Math.sqrt(dx * dx + dy * dy) > DRAG_THRESHOLD) {
                        return;
                    }
                }

                const insideAnimationContainer = e.target.closest('.EBizViewPopup');
                const filterDropdownPopup = e.target.closest('.grid-filter-dropdown-popup');
                const filterDatePickerPopup = e.target.closest('.datePickerPopupContainer');

                if (insideAnimationContainer || filterDropdownPopup || filterDatePickerPopup) {
                    return;
                }

                const clickedOutsideAll = elementIds.every(elementId => {
                    const element = document.getElementById(elementId);
                    const isOutside = !element?.contains(e.target);
                    return isOutside;
                });

                if (clickedOutsideAll) {
                    dotnetHelper.invokeMethodAsync('OnClickOutside');
                }
            };

            listeners.set(instanceId, listener);
            document.addEventListener('click', listener);
        },

        dispose: function (instanceId) {
            if (listeners.has(instanceId)) {
                document.removeEventListener('click', listeners.get(instanceId));
                listeners.delete(instanceId);
            }
        }
    };
})();

window.ApplyBoxShadowToGridContent = function (grid, gridContent, options = {}) {

    const layoutDetails = options.layoutDetails !== false;

    // Shadow tuning constants — `strength` scales the base values.
    const shadowStrength = 1.5;
    const base = {
        offsetX: 5,
        offsetY: 0,
        blur: 20,
        spread: -5,
        color: '0,0,0',
        opacity: 0.08
    };

    const offsetX = base.offsetX * shadowStrength;
    const offsetY = base.offsetY * shadowStrength;
    const blur = base.blur * shadowStrength;
    const spread = base.spread * shadowStrength;
    const opacity = Math.min(base.opacity * shadowStrength, 1);

    const boxShadowLeft = `${offsetX}px ${offsetY}px ${blur}px ${spread}px rgba(${base.color},${opacity})`;
    const boxShadowRight = `-${offsetX}px ${offsetY}px ${blur}px ${spread}px rgba(${base.color},${opacity})`;
    const boxShadowNone = `none`;

    let gridHeader = grid.querySelector(".k-grid-aria-root .k-grid-header .k-grid-header-wrap .k-grid-header-table thead > tr");
    let stickyHeaders = gridHeader ? gridHeader.querySelectorAll(".k-grid-header-sticky") : [];
    const totalCols = gridHeader ? gridHeader.querySelectorAll("th").length : 0;

    let leftStickyHeader = null;
    let rightStickyHeader = null;
    let leftGroupHeaders = [];
    let rightGroupHeaders = [];

    let stickyHeadersArray = Array.from(stickyHeaders).map(h => ({
        element: h,
        colIndex: parseInt(h.getAttribute('data-col-index'), 10)
    }));
    stickyHeadersArray.sort((a, b) => a.colIndex - b.colIndex);

    if (stickyHeadersArray.length > 0) {
        let maxGap = 1;       // anything <= 1 means contiguous, so start here
        let splitIndex = -1;  // index in the sorted array where the gap sits

        for (let i = 0; i < stickyHeadersArray.length - 1; i++) {
            const gap = stickyHeadersArray[i + 1].colIndex - stickyHeadersArray[i].colIndex;
            if (gap > maxGap) {
                maxGap = gap;
                splitIndex = i;
            }
        }

        if (splitIndex !== -1) {
            // A gap exists — clear left/right split
            leftGroupHeaders = stickyHeadersArray.slice(0, splitIndex + 1).map(x => x.element);
            rightGroupHeaders = stickyHeadersArray.slice(splitIndex + 1).map(x => x.element);
            leftStickyHeader = stickyHeadersArray[splitIndex].element;       // rightmost of left group
            rightStickyHeader = stickyHeadersArray[splitIndex + 1].element;  // leftmost of right group
        } else {
            // All sticky columns are contiguous — decide which side they belong to
            // by checking whether the group touches the left or right edge of the grid
            const firstIndex = stickyHeadersArray[0].colIndex;
            const lastIndex = stickyHeadersArray[stickyHeadersArray.length - 1].colIndex;

            if (lastIndex < totalCols - 1) {
                // Doesn't reach the right edge → entire group is on the left
                leftGroupHeaders = stickyHeadersArray.map(x => x.element);
                leftStickyHeader = stickyHeadersArray[stickyHeadersArray.length - 1].element;
            } else if (firstIndex > 0) {
                // Doesn't reach the left edge → entire group is on the right
                rightGroupHeaders = stickyHeadersArray.map(x => x.element);
                rightStickyHeader = stickyHeadersArray[0].element;
            }
            // else: every column is sticky — no scrollable content, no shadow needed
        }
    }

    // Full widths of the floating column groups — the boundary detail rows align to.
    const sumHeaderWidths = els => els.reduce((t, el) => t + el.getBoundingClientRect().width, 0);
    const leftGroupWidth = sumHeaderWidths(leftGroupHeaders);
    const rightGroupWidth = sumHeaderWidths(rightGroupHeaders);

    // Sizes the sidings and detail-content indents (consumed via CSS vars by
    // EBizGrid.razor/.css). Set on the grid root so Blazor re-renders can't
    // wipe them, and unconditionally so non-subgrid detail rows align too.
    grid.style.setProperty('--ebiz-left-sticky-width', leftGroupWidth + 'px');
    grid.style.setProperty('--ebiz-right-sticky-width', rightGroupWidth + 'px');

    if (layoutDetails) {
        layoutDetailSubgrids(grid, gridContent, leftGroupWidth, rightGroupWidth);
        layoutGroupFrames(grid);
    }

    // Ownership filter: a subgrid inside a detail row has its own rows and
    // sticky cells under this grid's content element — never paint those.
    let rows = Array.from(gridContent.querySelectorAll("table > tbody > tr"))
        .filter(row => row.closest('.ebizgrid') === grid);
    let leftStickyCells = [];
    let rightStickyCells = [];

    const leftColIndex = leftStickyHeader ? parseInt(leftStickyHeader.getAttribute('data-col-index'), 10) : null;
    const rightColIndex = rightStickyHeader ? parseInt(rightStickyHeader.getAttribute('data-col-index'), 10) : null;

    rows.forEach(row => {
        row.querySelectorAll(".k-grid-content-sticky").forEach(cell => {
            const cellColIndex = parseInt(cell.getAttribute('data-col-index'), 10);
            if (leftColIndex !== null && cellColIndex === leftColIndex) leftStickyCells.push(cell);
            if (rightColIndex !== null && cellColIndex === rightColIndex) rightStickyCells.push(cell);
        });
    });

    // Telerik computes the locked-column left/right offsets from DECLARED column
    // widths, which include its auto-rendered hierarchy (detail expander) column.
    // That column is hidden with display:none (grid.css), so the rendered table
    // collapses it and the declared offsets overshoot — the pinned cells no
    // longer tile flush and scrolled content bleeds through the gap between
    // them. Re-derive each pinned column's offset from the ACTUAL rendered
    // widths of the pinned columns before it (identical to Telerik's values
    // whenever nothing is hidden) and overwrite the inline styles on the header
    // and every owned body cell.
    const normalizeStickyOffsets = (groupHeaders, side) => {
        if (!groupHeaders.length) return;
        let offset = 0;
        const ordered = side === 'right' ? [...groupHeaders].reverse() : groupHeaders;
        ordered.forEach(header => {
            const colIndex = header.getAttribute('data-col-index');
            const px = offset + 'px';
            header.style[side] = px;
            rows.forEach(row => {
                row.querySelectorAll(`.k-grid-content-sticky[data-col-index="${colIndex}"]`)
                    .forEach(cell => {
                        // A subgrid inside a detail row can reuse the same
                        // data-col-index — never restyle another grid's cells.
                        if (cell.closest('.ebizgrid') === grid) cell.style[side] = px;
                    });
            });
            offset += header.getBoundingClientRect().width;
        });
    };
    normalizeStickyOffsets(leftGroupHeaders, 'left');
    normalizeStickyOffsets(rightGroupHeaders, 'right');

    const scrollLeft = gridContent.scrollLeft;
    const visibleWidth = gridContent.clientWidth;
    const totalWidth = gridContent.scrollWidth;
    const canScrollLeft = scrollLeft > 0;
    const canScrollRight = Math.ceil(scrollLeft + visibleWidth) < totalWidth;

    // Keep group-footer rows horizontally centered regardless of browser.
    // CSS position:sticky on <tr> is not reliably honoured by Firefox, so we
    // compensate with a translateX that offsets the scroll position, pinning
    // each footer to the left edge of the visible viewport on every frame.
    // At the same time, apply CSS flex order to each TD so that columns with
    // an explicit FooterOrder value sort before unordered ones (which retain
    // their column-declaration order among themselves).
    Array.from(grid.querySelectorAll('tr.k-group-footer'))
        .filter(r => r.closest('.ebizgrid') === grid)
        .forEach(row => {
            row.style.transform = `translateX(${scrollLeft}px)`;

            const tds = Array.from(row.querySelectorAll(':scope > td'));
            // Unordered entries get a sentinel that is always larger than any
            // reasonable FooterOrder integer, preserving their relative DOM order.
            const unorderedBase = Number.MAX_SAFE_INTEGER - tds.length;
            tds.forEach((td, domIndex) => {
                const anchor = td.querySelector('[data-footer-order]');
                const raw = anchor?.getAttribute('data-footer-order');
                td.style.order = (raw !== null && raw !== undefined && raw !== '')
                    ? parseInt(raw, 10)
                    : unorderedBase + domIndex;
            });
        });

    // Drive per-edge corner rounding (see EBizGrid.razor.css): while a NON-sticky
    // edge can still scroll, its content bleeds off under the fade overlay, so
    // that edge's corners are squared; once the edge reaches the scroll end the
    // corners round again. An edge backed by a sticky column group keeps its
    // rounded corners always (the sticky cell, not bleeding content, owns the
    // corner) — so only square an edge that has no sticky group there, mirroring
    // where the fade overlay is shown. Set on the content and header (they scroll
    // together) so the rounding tracks the live scroll position.
    const hasLeftSticky = leftStickyHeader && leftStickyCells.length;
    const hasRightSticky = rightStickyHeader && rightStickyCells.length;
    const leftEdge = (!hasLeftSticky && canScrollLeft) ? 'true' : 'false';
    const rightEdge = (!hasRightSticky && canScrollRight) ? 'true' : 'false';
    gridContent.dataset.canScrollLeft = leftEdge;
    gridContent.dataset.canScrollRight = rightEdge;
    const headerEl = grid.querySelector('.k-grid-header');
    if (headerEl) {
        headerEl.dataset.canScrollLeft = leftEdge;
        headerEl.dataset.canScrollRight = rightEdge;
    }

    // NOTE: there is deliberately NO scroll-position-dependent clip on the
    // first/last master rows anymore. The old approach shifted the rows'
    // clip-path insets by scrollLeft each frame so the row background rounded
    // at the viewport edge — but composited scrolling presents frames between
    // main-thread updates, so the insets were stale mid-fling (clipping the
    // pinned sticky cells away entirely) and again for the first frames when a
    // scroll STARTED from a settled position (corner cells flickered). Corner
    // rounding on sticky sides is now painted by .ebiz-corner-* masks that
    // live inside the pinned cells themselves (see below): they move with the
    // cells on the compositor thread and can never lag the scroll.

    // One routine drives both floating column groups — left and right are
    // mirror images, differing only in which margin/edge they pin to and which
    // siding classes they use.
    //
    // When the side has a sticky group: shadow + clip the header and its cells,
    // then inject (once) a detail-row siding into Telerik's .k-detail-cell TD.
    // The siding sits in a full-bleed track (absolute, inset:0) and is pinned to
    // the scroll viewport edge by NATIVE position:sticky — no per-frame JS, so it
    // can't trail the real sticky columns, and the track's containing block spans
    // the TD's full width (past its padding) so the siding reaches the true edge
    // at the scroll extreme instead of being clamped inside the padding. Height
    // is CSS (track definite-height → siding height:100%); JS only refreshes
    // shadow/clip. When the side has no sticky group, fall back to a fade overlay.
    const applySide = ({ side, stickyHeader, stickyCells, canScroll, shadow, clip, marginProp, trackClass, sidingClass, footerTrackClass, footerSidingClass }) => {
        if (!stickyHeader || !stickyCells.length) {
            setFadeOverlay(grid.querySelector('.k-grid-header'), { side, show: canScroll, shadow });
            setFadeOverlay(grid.querySelector('.k-grid-container'), { side, show: canScroll, shadow });
            return;
        }

        const shadowValue = canScroll ? shadow : boxShadowNone;
        const clipValue = canScroll ? clip : 'none';

        // The shadow clip is a plain rectangle extending 40px past the inner
        // edge to reveal the shadow. It deliberately does NOT round the outer
        // corners — the grid-edge rounding is painted by the .ebiz-corner-*
        // masks applied after both sides run (a rounded clip here would cut the
        // mask's corner off).
        stickyHeader.style.boxShadow = shadowValue;
        stickyHeader.style.clipPath = clipValue;
        stickyHeader.style[marginProp] = "8px";
        stickyHeader.style.marginTop = "8px";
        stickyCells.forEach(cell => {
            cell.style.boxShadow = shadowValue;
            cell.style.clipPath = clipValue;
        });

        Array.from(grid.querySelectorAll('.k-detail-row > td'))
            .filter(td => td.closest('.ebizgrid') === grid)
            .forEach(td => {
                let track = td.querySelector(`:scope > .${trackClass}`);
                if (!track) {
                    track = document.createElement('div');
                    track.className = trackClass;
                    const newSiding = document.createElement('div');
                    newSiding.className = sidingClass;
                    track.appendChild(newSiding);
                    td.insertBefore(track, td.firstChild);
                }
                const siding = track.querySelector(`:scope > .${sidingClass}`);
                siding.style.boxShadow = shadowValue;
                siding.style.clipPath = clipValue;
            });

        // Group sidings. The inter-group gap spacer is a flex strip with no real
        // sticky cells of its own, so the floating-column shadow would otherwise stop
        // at it. Inject (once) a siding into each gap spacer's sticky-column zone,
        // pinned to the viewport edge by NATIVE position:sticky inside a full-bleed
        // track, carrying the same shadow/clip as the real sticky cells so the shadow
        // runs unbroken through the gap between groups.
        // Note: group footer rows (tr.k-group-footer) intentionally do NOT get sidings.
        if (footerTrackClass && footerSidingClass) {
            Array.from(grid.querySelectorAll('tr.k-grouping-row:not(:first-child)'))
                .filter(r => r.closest('.ebizgrid') === grid)
                .forEach(row => {
                    let track = row.querySelector(`:scope > .${footerTrackClass}`);
                    if (!track) {
                        track = document.createElement('div');
                        track.className = footerTrackClass;
                        const newSiding = document.createElement('div');
                        newSiding.className = footerSidingClass;
                        track.appendChild(newSiding);
                        row.appendChild(track);
                    }
                    const siding = track.querySelector(`:scope > .${footerSidingClass}`);
                    siding.style.boxShadow = shadowValue;
                    siding.style.clipPath = clipValue;
                });
        }
    };

    // The ACTUAL outermost visible cell of a row — the grid-edge corner cell.
    // It isn't always the shadow (inner sticky) column: multi-column groups put
    // the shadow on the inner column, and a pinned expander cell can sit
    // outside the sticky columns.
    const firstVisibleCell = (row) => Array.from(row.cells).find(c => c.offsetWidth > 0);
    const lastVisibleCell = (row) => {
        const cells = Array.from(row.cells);
        for (let i = cells.length - 1; i >= 0; i--) {
            if (cells[i].offsetWidth > 0) return cells[i];
        }
        return null;
    };

    applySide({
        side: 'left',
        stickyHeader: leftStickyHeader,
        stickyCells: leftStickyCells,
        canScroll: canScrollLeft,
        shadow: boxShadowLeft,
        clip: 'inset(0px -40px 0px 0px)',
        marginProp: 'marginLeft',
        trackClass: 'detail-siding-left-track',
        sidingClass: 'detail-siding-left',
        footerTrackClass: 'gf-siding-left-track',
        footerSidingClass: 'gf-siding-left',
    });

    applySide({
        side: 'right',
        stickyHeader: rightStickyHeader,
        stickyCells: rightStickyCells,
        canScroll: canScrollRight,
        shadow: boxShadowRight,
        clip: 'inset(0px 0px 0px -40px)',
        marginProp: 'marginRight',
        trackClass: 'detail-siding-right-track',
        sidingClass: 'detail-siding-right',
        footerTrackClass: 'gf-siding-right-track',
        footerSidingClass: 'gf-siding-right',
    });

    // Corner masks: on a sticky side the grid-edge corner belongs to a PINNED
    // cell, so its rounding must move with the pinned cell — any clip computed
    // from scrollLeft lags composited scrolling and flickers. Instead the four
    // outer corner cells get .ebiz-corner-* classes whose ::after (CSS) paints
    // an inverted-quarter-circle in the grid's surrounding background colour
    // over the cell's square corner. The mask is a child of the sticky cell, so
    // the compositor carries it along with the pin — zero per-frame JS.
    // Non-sticky edges keep the CSS square/round scroll-state rules.
    {
        const CORNER_CLASSES = ['ebiz-corner-tl', 'ebiz-corner-tr', 'ebiz-corner-bl', 'ebiz-corner-br'];
        const desired = new Map(); // cell -> Set of corner classes
        const addCorner = (cell, cls) => {
            if (!cell) return;
            if (!desired.has(cell)) desired.set(cell, new Set());
            desired.get(cell).add(cls);
        };

        const masterRows = rows.filter(r => r.classList.contains('k-master-row'));
        if (masterRows.length) {
            const firstRow = masterRows[0];
            const lastRow = masterRows[masterRows.length - 1];
            if (hasLeftSticky) {
                addCorner(firstVisibleCell(firstRow), 'ebiz-corner-tl');
                addCorner(firstVisibleCell(lastRow), 'ebiz-corner-bl');
            }
            if (hasRightSticky) {
                addCorner(lastVisibleCell(firstRow), 'ebiz-corner-tr');
                addCorner(lastVisibleCell(lastRow), 'ebiz-corner-br');
            }
        }

        // Drop classes from cells that are no longer corner cells (sort/filter/
        // paging can change which rows are first/last).
        grid.querySelectorAll('td.ebiz-corner-cell').forEach(cell => {
            if (cell.closest('.ebizgrid') !== grid) return;
            if (!desired.has(cell)) cell.classList.remove('ebiz-corner-cell', ...CORNER_CLASSES);
        });

        desired.forEach((corners, cell) => {
            cell.classList.add('ebiz-corner-cell');
            CORNER_CLASSES.forEach(cls => cell.classList.toggle(cls, corners.has(cls)));
            // A corner cell that isn't the shadow column has no inner-edge
            // shadow clip; clear any inline clip so nothing cuts the mask.
            const colIndex = parseInt(cell.getAttribute('data-col-index'), 10);
            if (colIndex !== leftColIndex && colIndex !== rightColIndex) {
                cell.style.clipPath = '';
            }
        });
    }
};


// Draws one viewport-fixed, rounded frame per group (its data rows + footer) so the
// grouped data reads as separate stacked cards instead of one continuous box with a
// notch between sections. The frames live on the non-scrolling .k-grid-container
// (left:0/right:0), so their left/right sides stay pinned to the visible edges while
// the columns scroll, and each frame ends at its footer's bottom — the horizontal
// scrollbar sits below, outside every frame. The grouping-row spacer that creates the
// gap falls between consecutive frames. Recomputed on render/resize only: group
// positions are fixed vertically (the content has no vertical scroll) and horizontal
// scrolling doesn't move the frames.
function layoutGroupFrames(grid) {
    const container = grid.querySelector('.k-grid-aria-root .k-grid-container');
    if (!container) return;

    // Clear any frames from a previous pass before re-measuring.
    container.querySelectorAll(':scope > .ebiz-group-frame').forEach(f => f.remove());
    if (!grid.classList.contains('grouping-enabled')) return;

    const table = container.querySelector('.k-grid-content .k-grid-table');
    const tbody = table?.querySelector('tbody') ?? table?.lastElementChild;
    if (!tbody) return;

    // A group is the run of rows up to and including its footer; grouping rows are
    // separators between groups (and the hidden first one), never part of a group.
    const rows = Array.from(tbody.children).filter(r => r.closest('.ebizgrid') === grid);
    const groups = [];
    let current = [];
    for (const row of rows) {
        if (row.classList.contains('k-grouping-row')) {
            if (current.length) { groups.push(current); current = []; }
            continue;
        }
        current.push(row);
        if (row.classList.contains('k-group-footer')) { groups.push(current); current = []; }
    }
    if (current.length) groups.push(current);

    const containerTop = container.getBoundingClientRect().top;
    groups.forEach(group => {
        const top = group[0].getBoundingClientRect().top - containerTop;
        const bottom = group[group.length - 1].getBoundingClientRect().bottom - containerTop;
        if (bottom <= top) return;
        const frame = document.createElement('div');
        frame.className = 'ebiz-group-frame';
        frame.style.top = `${top}px`;
        frame.style.height = `${bottom - top}px`;
        container.appendChild(frame);
    });
}


// Sizes detail wrappers that host a subgrid based on whether the subgrid fits
// in the scroll viewport between the floating column groups.
//
// Fits      → data-detail-fits="true": the wrapper pins to the viewport
//             (position: sticky, CSS) and the subgrid stays centered in the
//             area the floating columns leave free, even during scrolling.
// Overflows → the wrapper is widened to the subgrid's full natural width
//             (overriding the viewport max-width cap) so it scrolls with the
//             parent table and slides behind the floating columns on both
//             sides, covered by the sidings.
//
// All state lives in a data attribute and inline width — channels Blazor
// doesn't render — so re-renders can't wipe the decision. Runs only from the
// render/resize path (layoutDetails), never per scroll event.
function layoutDetailSubgrids(grid, gridContent, leftGroupWidth, rightGroupWidth) {
    const wrappers = grid.querySelectorAll('.detail-expand-wrapper.detail-has-subgrid');
    if (!wrappers.length) return;

    // 32px = the detail cell's horizontal padding; a sticky wrapper sits inside
    // that padding, so without this allowance an exactly-fitting subgrid would
    // have its last pixels pushed past the scrollport edge.
    const available = gridContent.clientWidth - leftGroupWidth - rightGroupWidth - 32;

    // Total non-sticky horizontal extent of the parent grid.  A subgrid narrower
    // than this can be fully revealed by scrolling the parent (state 2).  One
    // wider than this cannot — it needs its own scrollbar (state 3).
    const nonStickyScrollWidth = gridContent.scrollWidth - leftGroupWidth - rightGroupWidth;

    wrappers.forEach(wrapper => {
        // Only manage this grid's own detail rows, not wrappers nested deeper
        // inside one of its subgrids.
        if (wrapper.closest('.ebizgrid') !== grid) return;

        // The nested grid's data table keeps its natural (column-sum) width
        // even when the wrapper clips it, so it's a stable measure.
        const nestedTable = wrapper.querySelector('.detail-fade-content .k-grid-content table');
        const naturalWidth = nestedTable ? nestedTable.getBoundingClientRect().width : 0;

        // Hysteresis: once pinned, stay pinned until clearly too wide so
        // measurement jitter at the boundary can't flap between modes.
        const wasFits = wrapper.dataset.detailFits === 'true';
        const fits = naturalWidth > 0 &&
            (wasFits ? naturalWidth <= available + 12 : naturalWidth <= available);

        if (fits) {
            // State 1: subgrid fits between the two sticky column groups.
            // CSS ([data-detail-fits="true"]) supplies sticky + left: 0 + centering.
            wrapper.dataset.detailFits = 'true';
            wrapper.style.width = '';
            wrapper.style.maxWidth = '';
            wrapper.style.position = '';
            wrapper.style.left = '';
        } else {
            const td = wrapper.closest('td');
            const cap = td ? td.clientWidth - 32 : Infinity;

            if (naturalWidth > nonStickyScrollWidth) {
                // State 3: subgrid is wider than all parent non-sticky columns
                // combined.  Size the wrapper to fill that non-sticky area and let
                // Telerik render its own horizontal scrollbar inside.
                wrapper.dataset.detailFits = 'overflow';
                const target = Math.min(Math.ceil(leftGroupWidth + nonStickyScrollWidth + rightGroupWidth), cap);
                wrapper.style.maxWidth = 'none';
                wrapper.style.width = target + 'px';
                wrapper.style.position = 'sticky';
                wrapper.style.left = Math.min(0, gridContent.clientWidth - target) + 'px';
            } else {
                // State 2: subgrid fits within the parent's total scroll extent.
                // Size wrapper to the subgrid's full natural width and let it ride
                // the parent scroll 1:1 — no own scrollbar (CSS suppresses it).
                // Sticky with a negative left clamp keeps the wrapper in view if the
                // parent table is wider than the subgrid and scrolls past it.
                wrapper.dataset.detailFits = 'false';
                const target = Math.min(Math.ceil(leftGroupWidth + naturalWidth + rightGroupWidth), cap);
                wrapper.style.maxWidth = 'none';
                wrapper.style.width = target + 'px';
                wrapper.style.position = 'sticky';
                wrapper.style.left = Math.min(0, gridContent.clientWidth - target) + 'px';
            }
        }
    });
}


function setFadeOverlay(container, options = {}) {
    if (!container) return;

    const {
        side = 'right',
        show = true,
        className = side === 'right' ? 'grid-right-fade' : 'grid-left-fade',
        shadow = null,
    } = options;

    const existing = container.querySelector(`.${className}`);
    if (existing) existing.remove();

    if (!show || !shadow) return;

    const fadeDiv = document.createElement('div');
    fadeDiv.className = className;

    // Mirror the sticky-column shadow on a non-sticky scrolling edge: anchor a
    // content-less element just OFF the grid edge so its inner edge sits exactly
    // on the scroll boundary, cast the SAME box-shadow inward, and reveal it
    // through a 40px clip — identical geometry to the sticky cells, so the soft
    // tuned shadow appears at the edge instead of a flat gradient. The body sits
    // outside the grid (transparent, clipped away), leaving only the shadow.
    const isRight = side === 'right';
    Object.assign(fadeDiv.style, {
        position: 'absolute',
        top: 0,
        [isRight ? 'right' : 'left']: '-40px',
        width: '40px',
        height: computeFadeHeight(container),
        pointerEvents: 'none',
        boxShadow: shadow,
        clipPath: isRight ? 'inset(0px 40px 0px -40px)' : 'inset(0px -40px 0px 40px)',
        zIndex: 2,
    });

    if (getComputedStyle(container).position === 'static') {
        container.style.position = 'relative';
    }
    container.appendChild(fadeDiv);
}

// Cap the fade overlay so it stops where an expanded detail row begins
// (preventing the gradient from painting over child grids inside detail
// templates) and at the bottom of the last data row (so it doesn't bleed into
// the padded gap above the horizontal scrollbar — the sticky-cell shadow stops
// at the rows too, so the fade should match).
function computeFadeHeight(container) {
    const containerRect = container.getBoundingClientRect();
    const containerHeight = containerRect.height;
    let cap = containerHeight;

    const detailRows = container.querySelectorAll('tr.k-detail-row');
    for (const dr of detailRows) {
        const drRect = dr.getBoundingClientRect();
        const top = drRect.top - containerRect.top;
        const bottom = drRect.bottom - containerRect.top;

        if (top <= 0 && bottom > 0) {
            cap = 0;
            break;
        }
        if (top > 0 && top < cap) {
            cap = top;
        }
    }

    // Stop at the bottom of the last data row that sits within the current cap,
    // trimming the bottom padding/scrollbar gap from the shadow.
    let rowBottom = 0;
    for (const r of container.querySelectorAll('tr.k-master-row')) {
        const bottom = r.getBoundingClientRect().bottom - containerRect.top;
        if (bottom <= cap && bottom > rowBottom) rowBottom = bottom;
    }
    if (rowBottom > 0 && rowBottom < cap) cap = rowBottom;

    if (cap <= 0) return '0px';
    if (cap >= containerHeight) return '100%';
    return `${Math.round(cap)}px`;
}


globalThis.applyPagerCss = (gridId) => {
    const pager = document.querySelector(`#${gridId} .EBizGridPager`);
    if (!pager) return;

    const sizes = pager.querySelector('.k-pager-sizes');
    if (!sizes) return;

    const ddl = sizes.querySelector('[role="combobox"][aria-controls]');
    if (!ddl) return;

    const listId = ddl.getAttribute('aria-controls');
    if (!listId) return;

    const listEl = document.getElementById(listId);
    const containerEl = listEl ? listEl.closest('.k-animation-container') : null;
    const containerId = containerEl?.id || "";

    const prevKey = pager.dataset.pagerCssKey;
    const newKey = containerId || listId;
    if (prevKey && prevKey !== newKey) {
        const old = document.getElementById(`pagerCss_${prevKey}`);
        if (old) { old.remove(); console.log("[applyPagerCss] removed old style for", prevKey); }
    }
    pager.dataset.pagerCssKey = newKey;

    const baseSel = containerId
        ? `#${CSS.escape(containerId)}`
        : `.k-animation-container:has(#${CSS.escape(listId)})`;

    const css = `
    /* shift the popup container (NOT the UL) */
    ${baseSel} { transform: translateY(-4px); }

    /* container sizing (formerly global .k-animation-container:has(.k-dropdownlist-popup) rule) */
    ${baseSel} { max-height: none !important; }

    /* popup chrome (formerly global .k-popup.k-dropdownlist-popup rule) */
    ${baseSel} .k-dropdownlist-popup {
      box-sizing: content-box !important;
      padding: 4px; border-radius: 8px; box-shadow: 0 4px 20px rgba(0,0,0,0.08);
    }

    ${baseSel} .k-list-content:has(>#${CSS.escape(listId)}) {
      overflow-y: hidden !important;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* legacy Edge */
    }

    ${baseSel} .k-list-content:has(>#${CSS.escape(listId)})::-webkit-scrollbar {
      display: none; /* Chromium, Safari */
    }

    /* list item styles (safe to anchor on UL id) */
    #${CSS.escape(listId)} li {
      flex-grow: 0; display: flex; flex-direction: row; justify-content: space-between; align-items: center;
      padding: 8px 12px; border-radius: 8px; color: var(--colors-content-primary) !important; box-shadow: none !important;
    }
    #${CSS.escape(listId)} li.k-selected { background-color: var(--dropdown-dropdown-item-selected); }
    #${CSS.escape(listId)} li:hover { background-color: var(--dropdown-dropdown-item-hover); }
    #${CSS.escape(listId)} li > span {
      flex-grow: 0; font-family: ProximaNova, Helvetica, Arial, Verdana, Tahoma, sans-serif;
      font-size: 14px; line-height: 1.43; color: var(--colors-content-primary);
    }
  `;

    const styleId = `pagerCss_${newKey}`;
    let style = document.getElementById(styleId);
    if (!style) {
        style = document.createElement('style');
        style.id = styleId;
        document.head.appendChild(style);
    }
    style.textContent = css;
};

globalThis.fixCheckboxWraps = function () {
    const wraps = document.querySelectorAll('.k-table-td .k-checkbox-wrap');
    wraps.forEach((wrap) => {
        wrap.style.padding = '4px';
        wrap.style.margin = '-4px';
        wrap.style.cursor = 'pointer';

        // Only attach the event once
        if (!wrap.__checkboxWrapHandlerAttached) {
            wrap.addEventListener('click', (e) => {
                if (!e.target.classList.contains('k-checkbox')) {
                    const checkbox = wrap.querySelector('.k-checkbox');
                    if (checkbox) {
                        checkbox.click();
                    }
                }
            });
            wrap.__checkboxWrapHandlerAttached = true;
        }
    });
};

globalThis._fixCheckboxWrapsDebounced = debounce(globalThis.fixCheckboxWraps, 100);

window.EBizDetailWidthObserver = (function () {
    const observers = new Map();

    function findContent(gridEl) {
        if (!gridEl) return null;
        return gridEl.querySelector('.k-grid-aria-root .k-grid-container .k-grid-content')
            || gridEl.querySelector('.k-grid-content');
    }

    function updateWidth(state) {
        if (!state.gridEl || !state.contentEl) return;
        const w = state.contentEl.clientWidth;
        if (w > 0) {
            state.gridEl.style.setProperty('--ebiz-detail-max-width', w + 'px');
        }
    }

    function teardown(gridId, state) {
        if (state.rafId) cancelAnimationFrame(state.rafId);
        state.resizeObs?.disconnect();
        state.mutationObs?.disconnect();
        state.gridEl?.style.removeProperty('--ebiz-detail-max-width');
        observers.delete(gridId);
    }

    return {
        init: function (gridId) {
            if (!gridId || observers.has(gridId)) return;

            const tryAttach = (tries) => {
                const gridEl = document.getElementById(gridId);
                const contentEl = findContent(gridEl);

                if (!gridEl || !contentEl) {
                    if (tries < 30) {
                        setTimeout(() => tryAttach(tries + 1), 100);
                    }
                    return;
                }

                const state = { gridEl, contentEl, rafId: 0, resizeObs: null, mutationObs: null };

                const schedule = () => {
                    if (state.rafId) return;
                    state.rafId = requestAnimationFrame(() => {
                        state.rafId = 0;
                        if (!state.gridEl.isConnected) {
                            teardown(gridId, state);
                            return;
                        }
                        // .k-grid-content can be replaced when Telerik re-renders the grid.
                        // Re-resolve and re-observe if the cached node is no longer attached.
                        if (!state.contentEl.isConnected) {
                            const fresh = findContent(state.gridEl);
                            if (!fresh) return;
                            state.contentEl = fresh;
                            state.resizeObs.disconnect();
                            state.resizeObs.observe(state.contentEl);
                        }
                        updateWidth(state);
                    });
                };

                state.resizeObs = new ResizeObserver(schedule);
                state.resizeObs.observe(contentEl);

                state.mutationObs = new MutationObserver(() => {
                    if (!state.gridEl.isConnected) {
                        teardown(gridId, state);
                    }
                });
                if (state.gridEl.parentNode) {
                    state.mutationObs.observe(state.gridEl.parentNode, { childList: true });
                }

                observers.set(gridId, state);
                updateWidth(state);
            };

            tryAttach(0);
        },

        dispose: function (gridId) {
            const state = observers.get(gridId);
            if (!state) return;
            teardown(gridId, state);
        }
    };
})();

// macOS "can't sort, always drags" header fix (SC-772).
//
// On macOS/WebKit a stationary mouse (or trackpad) press still emits a phantom
// `pointermove` at 0px; Windows emits none for a still press. Telerik's column
// reorder is a Kendo pointer-event Draggable, so that phantom move is enough for
// it to start a reorder drag and setPointerCapture() its drag clue — after which
// the `pointerup`/`click` that drives header sorting never reaches the header and
// the sort silently never fires. (The distance is 0px, so Kendo's own 9px
// threshold can't help — the trigger is the *existence* of the move, not its size.)
//
// We register a document capture-phase listener at load — earlier than the move
// listener Kendo binds per-press — and swallow near-zero pointermoves that land on
// a grid header, so a click stays a click. Genuine drags (movement past the
// tolerance) latch through untouched, so reorder and column-resize still work.
// Harmless on Windows (a still press emits no such move), so it runs everywhere.
(function () {
    if (window.__ebizGridSortReorderFix) return;
    window.__ebizGridSortReorderFix = true;

    const MOVE_TOLERANCE = 5; // px — below this, a header press is a click, not a drag
    let active = null;        // { id, x, y, onHeader, dragging }

    document.addEventListener('pointerdown', (e) => {
        const onHeader = e.target instanceof Element && e.target.closest('.k-grid-header') !== null;
        active = { id: e.pointerId, x: e.clientX, y: e.clientY, onHeader, dragging: false };
    }, true);

    document.addEventListener('pointermove', (e) => {
        if (!active || e.pointerId !== active.id || !active.onHeader || active.dragging) return;

        const dist = Math.hypot(e.clientX - active.x, e.clientY - active.y);
        if (dist > MOVE_TOLERANCE) {
            // Real drag — stop intercepting and let Telerik take over for the rest
            // of this gesture (reorder / column resize).
            active.dragging = true;
            return;
        }

        // Phantom / sub-threshold move on a header: hide it from Telerik so the
        // press stays a click and header sorting works on macOS.
        e.stopImmediatePropagation();
    }, true);

    const clear = (e) => {
        if (active && (!e || e.pointerId === active.id)) active = null;
    };
    document.addEventListener('pointerup', clear, true);
    document.addEventListener('pointercancel', clear, true);
})();

